export function timeLongFormat(time) {
    const [hours, minutes] = time.split(':')
    if (minutes === undefined) 
        return time
    return __("{h} h {m} min", { '{h}': parseInt(hours), '{m}': parseInt(minutes) })
}
